import React, { lazy, Suspense } from 'react'
import ComponentLoader from '../components/loader/ComponentLoader'
const  BasicTabs = lazy(()=>import('../commonComponent/Tabs'));

const NewFields = ({newFields}) => {
  return (
    <> {newFields?.map((elm,index)=>{
          return (
            <div ref={elm.ref} key={index} className="mt-[1rem] md:mt-[2rem]">
          <div>
          <picture>
            {/* Image for large screens */}
            <source 
              srcSet={elm.img[0]} 
              media="(min-width: 1024px)" 
            />
          
            {/* Image for small screens */}
            <source 
              srcSet={elm.img[1]}
              media="(max-width: 767px)" 
            />
            {/* Fallback image */}
            <img 
              src={elm.img[1]} 
              alt="Responsive Display" 
              className="w-full aspect-1570/480 lg:aspect-1440/200"        />
          </picture>
          
          </div>
          <div className="mx-auto w-full   bg-white my-5 md:my-10">
       {elm?.show&&   <Suspense fallback={<ComponentLoader />}>

            <BasicTabs tabFields={elm?.tabFields} />
          </Suspense>}
          </div>
          </div>
          )
        })  }</>
  )
}

export default NewFields